import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgFavorite({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.692 8.205l7.077 2.949A2 2 0 0111 13v7.86a.5.5 0 01-.685.465l-7.057-2.822a2 2 0 01-1.25-1.695L2 16.646v-7.98a.5.5 0 01.692-.461zM22 8.666v7.98a2 2 0 01-1.109 1.79l-.148.067-7.058 2.822A.5.5 0 0113 20.86v-8.529a1 1 0 01.615-.923l7.693-3.205a.5.5 0 01.692.462zm-9.257-6.369l8.084 3.234a.5.5 0 01-.003.93l-7.366 2.884a4 4 0 01-2.917 0L3.176 6.461a.5.5 0 01-.003-.93l8.084-3.234a2 2 0 011.486 0z"
        fill={color}
      />
    </svg>
  )
}

export default SvgFavorite
